import { render, staticRenderFns } from "./CvSidebar.vue?vue&type=template&id=2815f0bf&"
import script from "./CvSidebar.vue?vue&type=script&lang=js&"
export * from "./CvSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CvSidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports